import { Stack } from '@mui/material';
import React from 'react';

import Styled from "./LabelValue.styled";

/**
 * @component
 * @description Viewing data with label value combination
 * @param {object} props
 * @param {JSX.Element | string} props.label JSX or string
 * @param {JSX.Element | string} props.value JSX or string
 * @param {string | number} [props.gap] JSX or string
 */
const LabelValue = ({ 
  label,
  value,
  gap = 0.5,
}) => {
  return (
    <Stack gap={gap}>
      <Styled.Label>{label}</Styled.Label>
      <Styled.Value>{value}</Styled.Value>
    </Stack>
  )
}

export default LabelValue